var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailContacto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail",
    d: "M18.125-15H1.875A1.875,1.875,0,0,0,0-13.125v11.25A1.875,1.875,0,0,0,1.875,0h16.25A1.875,1.875,0,0,0,20-1.875v-11.25A1.875,1.875,0,0,0,18.125-15Zm0,1.875v1.594c-.876.713-2.272,1.822-5.257,4.16C12.21-6.854,10.907-5.611,10-5.625c-.907.015-2.21-1.229-2.868-1.746-2.985-2.337-4.381-3.446-5.257-4.16v-1.594ZM1.875-1.875v-7.25c.9.713,2.164,1.713,4.1,3.228C6.828-5.225,8.323-3.741,10-3.75c1.669.009,3.145-1.453,4.025-2.146,1.935-1.515,3.2-2.516,4.1-3.229v7.25Z",
    transform: "translate(0 15)",
    fill: "#0096c7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailContacto);
export default __webpack_public_path__ + "static/media/email-contacto.c635eb67f5548a5ea646a1ead4fa2996.svg";
export { ForwardRef as ReactComponent };